<template>
    <div ref="container" style="display: block;width: 100%;height: 100%;position: relative">
        <slot></slot>
    </div>
</template>

<style>
    .toolTip {
        position: absolute;
        display: none;
        height: auto;
        background: none repeat scroll 0 0 #ffffff;
        border: 1px solid #000000;
        border-radius: 3px;
        padding: 5px 10px;
        text-align: center;
        color: black;
    }
</style>

<script>
    import Vue from 'vue'
    import BarChart from './barchart.js'

    export default {
        name:"barchart",
        //передоваемые параметры
        props: {
            data: {
                type: Array,
                default: () => ([])
            },
            option: {
                type: Object,
                default: () => ({})
            }
        },
        // локальное состояние
        data() {
            return {
                defOprion: {
                    padding: {
                        left: 80,
                        right: 20,
                        top: 20,
                        bottom: 20,
                    },
                    axisLabels: {
                        x: "Axis X",
                        y: "Axis Y"
                    },
                    colored: true,
                    label: "label",
                    value: "value",
                    barLabelRotation: 135
                }
            }
        },
        mounted() {
            this.updateBarchart();
            window.addEventListener('resize', this.updateBarchart);
        },

        //вычисляемые свойства (https://ru.vuejs.org/v2/guide/computed.html#Вычисляемые-свойства)
        computed: {},
        //Методы для изменения локального состояния.Ограничения (https://ru.vuejs.org/v2/guide/list.html#Отслеживание-изменений-в-массивах)
        methods: {
            draw(data, options) {
                this.barChart = new BarChart(data, options);
            },
            redraw(data, options) {
                this.barChart.redraw(data, options);
            },
            updateBarchart() {
                const data = this.data;
                const options = {
                    width: this.$refs.container.clientWidth,
                    height: this.$refs.container.clientHeight,
                    container: this.$refs.container
                };

                for (let i in this.option)
                    if (this.option.hasOwnProperty(i) && 'undefined' !== typeof this.option[i])
                        options[i] = this.option[i];

                for (let i in this.defOprion)
                    if (this.defOprion.hasOwnProperty(i) && 'undefined' !== typeof this.defOprion[i] && 'undefined' === typeof options[i])
                        options[i] = this.defOprion[i];

                if (!this.barChart) this.draw(data, options);
                else this.redraw(data, options);
            }
        },

        components: {},

        watch: {
            data() {
                this.updateBarchart();
            },
            axisLabels() {
                this.updateBarchart();
            },
            colored() {
                this.updateBarchart();
            }
        }
    }
</script>

<style scoped>

</style>
